import { CMS_BASE_URL } from '@/utils/constants';

export const RESTSERVICES_BASE_URL = `${CMS_BASE_URL}/restservices/portal`;
